import styled from 'styled-components';

export const Header = styled.div`
  padding: 12px 16px;
  width: 100%;
  display: flex;
  position: relative;
  box-sizing: border-box;
  text-align: left;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.type.inverse};
  width: 100%;
  height: 100%;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  cursor: pointer;
  &:hover {
    color: white;
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.turquoise.T300
        : props.theme.atlas.semantic.color.action.primary.default};
  }
`;

export const StyledList = styled.ul`
  list-style-type: none;
  width: 100%;
  margin: 0px;
  padding: 8px 0px;
  a {
    padding-left: 32px;
  }
`;
